import { startTransition } from 'react';

import { RemoveDialog } from 'src/containers/Escrow/Remove';

import { useDashboard } from '../model';

const RemoveContainer = () => {
  const { removeDialogOpen, removeEscrowId, setRemoveDialogOpen, refetchEscrows } = useDashboard();

  const onCloseDialog = () => startTransition(() => setRemoveDialogOpen(false, null));

  return (
    <RemoveDialog
      isOpen={removeDialogOpen}
      onClose={onCloseDialog}
      successCallback={refetchEscrows}
      escrowId={removeEscrowId ?? ''}
    />
  );
};

export default RemoveContainer;
